/**
 * Owner-facing badge text for the geo signal on mug-tap stamp approvals
 * (backlog #16). Pure display formatting only — the bucket/distance are
 * already computed and stored server-side (web/api/_lib/geo-signal.ts); this
 * never touches raw coordinates. Design is LOCKED: signal only, never a gate.
 */
export type GeoBucket = 'at_counter' | 'far';

export interface GeoBadge {
  label: string;
  tone: 'green' | 'amber';
}

/** Returns null when there's nothing to show (unknown/no signal). */
export function formatGeoBadge(
  bucket: GeoBucket | null | undefined,
  distanceM: number | null | undefined,
): GeoBadge | null {
  if (bucket === 'at_counter') return { label: '✓ AT THE COUNTER', tone: 'green' };
  if (bucket === 'far' && typeof distanceM === 'number' && Number.isFinite(distanceM)) {
    const dist = distanceM < 1000 ? `${distanceM}M` : `${(distanceM / 1000).toFixed(1)}KM`;
    return { label: `⚠ ~${dist} AWAY`, tone: 'amber' };
  }
  return null;
}
